import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";
import { Box, Button, Container, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { t } from "i18next";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (config.data && config.data.id === undefined && config.data.userId) {
         
        }
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const chimMoiOptions = [
    { label: "TẤT CẢ GAME", value: "all" },
    { label: "Tài Xỉu MD5", value: "md560s" },
    { label: "Xổ Số 75s", value: "xs75s" },
    { label: "Xổ Số 120s", value: "xs120s" },
    
    { label: "TX 45s - Sảnh 1", value: "tx45ssanh1" },
    { label: "TX 45s - Sảnh 2", value: "tx45ssanh2" },
    { label: "TX 45s - Sảnh 3", value: "tx45ssanh3" },
    { label: "TX 45s - Sảnh 4", value: "tx45ssanh4" },
    { label: "TX 45s - Sảnh 5", value: "tx45ssanh5" },
    { label: "TX 45s - Sảnh 6", value: "tx45ssanh6" },
    
    { label: "TX 60s - Sảnh 1", value: "tx60ssanh1" },
    { label: "TX 60s - Sảnh 2", value: "tx60ssanh2" },
    { label: "TX 60s - Sảnh 3", value: "tx60ssanh3" },
    { label: "TX 60s - Sảnh 4", value: "tx60ssanh4" },
    { label: "TX 60s - Sảnh 5", value: "tx60ssanh5" },
    { label: "TX 60s - Sảnh 6", value: "tx60ssanh6" },
    
    { label: "XĐ 45s - Sảnh 1", value: "xd45ssanh1" },
    { label: "XĐ 45s - Sảnh 2", value: "xd45ssanh2" },
    { label: "XĐ 45s - Sảnh 3", value: "xd45ssanh3" },
    { label: "XĐ 45s - Sảnh 4", value: "xd45ssanh4" },
    { label: "XĐ 45s - Sảnh 5", value: "xd45ssanh5" },
    { label: "XĐ 45s - Sảnh 6", value: "xd45ssanh6" },
    
    { label: "XĐ 60s - Sảnh 1", value: "xd60ssanh1" },
    { label: "XĐ 60s - Sảnh 2", value: "xd60ssanh2" },
    { label: "XĐ 60s - Sảnh 3", value: "xd60ssanh3" },
    { label: "XĐ 60s - Sảnh 4", value: "xd60ssanh4" },
    { label: "XĐ 60s - Sảnh 5", value: "xd60ssanh5" },
    { label: "XĐ 60s - Sảnh 6", value: "xd60ssanh6" },
];

function Users() {
    const [users, setUsers] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [subModalType, setSubModalType] = useState(null); // 'nap' | 'rut' | 'cuoc' | null

    const navigate = useNavigate();
    const typingTimeoutRef = useRef(null);
    const limit = 12;

    const fetchUsers = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getall`, {
                params: {
                    page: page,
                    limit: limit,
                    search: searchQuery 
                }
            })
            .then((res) => {
                setUsers(res.data.data);
                setTotalPages(res.data.totalPages || 1);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, [page, searchQuery]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        
        typingTimeoutRef.current = setTimeout(() => {
            setSearchQuery(value);
            setPage(1);
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    function formatDate(m) {
        const d = new Date(m);
        return `${d.getFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const handleSetChimMoi = (userId, winValue) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
            id: userId,
            win: winValue
        }).then(() => {
            fetchUsers();
            swal(t("success"), "Đã cập nhật tính năng Auto Win!", "success");
        }).catch(() => {
            setLoading(false);
            swal(t("error"), "Có lỗi xảy ra khi cập nhật!", "error");
        });
    };

    const handleSetAllLeyiRtp = () => {
        swal({
            text: "Nhập tỷ lệ thắng Leyi cho TẤT CẢ người chơi (30 - 90, hoặc 0 để tắt):",
            content: {
                element: "input",
                attributes: {
                    placeholder: "Ví dụ: 75",
                    type: "number",
                },
            },
            buttons: ["Hủy", "Xác nhận"]
        }).then((value) => {
            if (value === null) return; // Clicked cancel
            const rtpVal = Number(value);
            if (value !== "0" && (isNaN(rtpVal) || rtpVal < 30 || rtpVal > 90)) {
                swal("Lỗi", "Tỷ lệ thắng hợp lệ phải từ 30 đến 90, hoặc 0 để tắt!", "error");
                return;
            }
            setLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}/auth/updateAllRtp`, {
                leyi_rtp: rtpVal
            }).then(() => {
                fetchUsers();
                swal(t("success"), `Đã cập nhật tỷ lệ thắng Leyi: ${rtpVal}% cho tất cả người chơi!`, "success");
            }).catch((err) => {
                setLoading(false);
                swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra khi cập nhật!", "error");
            });
        });
    };

    const handleMultiSelectChange = (userId, event) => {
        let selectedValues = event.target.value;

        if (selectedValues.includes("all")) {
            if (selectedValues[selectedValues.length - 1] === "all") {
                selectedValues = ["all"]; 
            } else {
                selectedValues = selectedValues.filter(val => val !== "all"); 
            }
        }
        const finalWinString = selectedValues.join(",");
        handleSetChimMoi(userId, finalWinString);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <div className="container_set">{t("users")}</div>
                        <div className="form_set">
                            <Box>
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
                                    <TextField 
                                        onChange={handleSearchChange} 
                                        placeholder={t("search")} 
                                        size="small"
                                        sx={{ width: "250px" }}
                                    />
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                        onClick={handleSetAllLeyiRtp}
                                        sx={{ 
                                            whiteSpace: "nowrap", 
                                            height: "40px", 
                                            fontWeight: "bold",
                                            textTransform: "none",
                                            borderRadius: "4px"
                                        }}
                                    >
                                        Cài RTP Leyi All User
                                    </Button>
                                </Box>
                                <Table className="table-admin">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>{t("username")}</TableCell>
                                            <TableCell>{t("balance")}</TableCell>
                                            <TableCell sx={{ minWidth: "200px" }}>{t("with_reg")}</TableCell>
                                            
                                            <TableCell sx={{ minWidth: "250px", color: "#d32f2f", fontWeight: "bold" }}>AUTO WIN</TableCell>
                                            <TableCell sx={{ minWidth: "150px", color: "#1976d2", fontWeight: "bold" }}>RTP LEYI (PGS)</TableCell>
                                            
                                            <TableCell>{t("reward")}</TableCell>
                                            <TableCell>{t("bank")}</TableCell>
                                            <TableCell>{t("phone")}</TableCell>
                                            <TableCell>{t("totalbet")}</TableCell>
                                            <TableCell>{t("ip")}</TableCell>
                                            <TableCell>{t("created")}</TableCell>
                                            <TableCell>{t("more")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users && users.length > 0 ? (
                                            users.map((item) => {
                                                // Tách chuỗi win thành mảng để đưa vào Select Multiple
                                                const currentWinArray = item?.win ? item.win.split(',').map(s => s.trim()) : [];
                                                
                                                return (
                                                    <TableRow key={item._id} sx={{ verticalAlign: "top", backgroundColor: item?.win ? "rgba(255, 0, 0, 0.05)" : "transparent" }}>
                                                        <TableCell>{item?.iduser}</TableCell>
                                                        <TableCell sx={{ fontWeight: item?.win ? "bold" : "normal", color: item?.win ? "#d32f2f" : "inherit" }}>
                                                            {item?.username}
                                                        </TableCell>
                                                        <TableCell>{item?.money?.toLocaleString("vi-VN")}</TableCell>
                                                        
                                                        <TableCell>
                                                            <form onSubmit={(e) => {
                                                                e.preventDefault();
                                                                setLoading(true);
                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
                                                                    id: item?._id,
                                                                    money: e.target.money.value,
                                                                    type: e.target.type.value
                                                                }).then(() => {
                                                                    fetchUsers();
                                                                    swal(t("success"), "", "success");
                                                                    e.target.reset();
                                                                }).catch(() => setLoading(false));
                                                            }}>
                                                                <input style={{ width: "80px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} name="money" type="number" placeholder={t("money")} required />
                                                                <Button type="submit" size="small" variant="contained" sx={{ ml: 1 }}>{t("submit")}</Button>
                                                                <br />
                                                                <div style={{ marginTop: "5px", fontSize: "13px" }}>
                                                                    <input name="type" type="radio" defaultChecked value="0" style={{ cursor: "pointer" }} /> Nạp tiền
                                                                    <input name="type" type="radio" value="1" style={{ cursor: "pointer", marginLeft: "10px" }} /> Trừ tiền
                                                                </div>
                                                            </form>
                                                        </TableCell>

                                                        {/* 🔥 DROPDOWN CHỌN NHIỀU SẢNH BẰNG MATERIAL UI 🔥 */}
                                                        <TableCell>
                                                            <Select
                                                                multiple
                                                                displayEmpty
                                                                value={currentWinArray}
                                                                onChange={(e) => handleMultiSelectChange(item._id, e)}
                                                                input={<OutlinedInput size="small" sx={{ 
                                                                    minWidth: "100%", 
                                                                    bgcolor: item?.win ? "#ffebee" : "#fff",
                                                                    fontWeight: item?.win ? "bold" : "normal",
                                                                    color: item?.win ? "#d32f2f" : "#333"
                                                                }} />}
                                                                renderValue={(selected) => {
                                                                    if (selected.length === 0) return <em style={{ color: '#aaa', fontStyle: 'normal' }}>Bình thường (Trống)</em>;
                                                                    if (selected.includes("all")) return "TẤT CẢ GAME";
                                                                    
                                                                    // Map value thành Label hiển thị cho đẹp
                                                                    return selected.map(val => {
                                                                        const found = chimMoiOptions.find(o => o.value === val);
                                                                        return found ? found.label : val;
                                                                    }).join(', ');
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps: { style: { maxHeight: 400, width: 250 } }
                                                                }}
                                                            >
                                                                {chimMoiOptions.map((opt) => (
                                                                    <MenuItem key={opt.value} value={opt.value} sx={{ py: 0 }}>
                                                                        <Checkbox checked={currentWinArray.indexOf(opt.value) > -1} />
                                                                        <ListItemText primary={opt.label} primaryTypographyProps={{ fontSize: '14px', fontWeight: opt.value === 'all' ? 'bold' : 'normal', color: opt.value === 'all' ? 'red' : 'inherit' }} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </TableCell>

                                                        {/* 🔥 Cài đặt tỷ lệ thắng RTP cho sảnh PGS (Leyi) 🔥 */}
                                                        <TableCell>
                                                            <span 
                                                                style={{ 
                                                                    color: item?.leyi_rtp ? "#1976d2" : "#333", 
                                                                    fontWeight: item?.leyi_rtp ? "bold" : "normal",
                                                                    cursor: "pointer",
                                                                    textDecoration: "underline",
                                                                    display: "inline-block",
                                                                    padding: "4px 8px",
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: "#f5f5f5",
                                                                    fontSize: "13px",
                                                                    textAlign: "center",
                                                                    minWidth: "70px"
                                                                }}
                                                                onClick={() => {
                                                                    swal({
                                                                        text: `Nhập tỷ lệ thắng Leyi (PGS) cho user ${item.username} (30 - 90, hoặc 0 để tắt):`,
                                                                        content: {
                                                                            element: "input",
                                                                            attributes: {
                                                                                placeholder: "Ví dụ: 75",
                                                                                type: "number",
                                                                                defaultValue: item?.leyi_rtp || ""
                                                                            },
                                                                        },
                                                                        buttons: ["Hủy", "Xác nhận"]
                                                                    }).then((value) => {
                                                                        if (value === null) return;
                                                                        const rtpVal = Number(value);
                                                                        if (value !== "0" && value !== "" && (isNaN(rtpVal) || rtpVal < 30 || rtpVal > 90)) {
                                                                            swal("Lỗi", "Tỷ lệ thắng hợp lệ phải từ 30 đến 90, hoặc 0 để tắt!", "error");
                                                                            return;
                                                                        }
                                                                        setLoading(true);
                                                                        axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
                                                                            id: item?._id,
                                                                            leyi_rtp: rtpVal
                                                                        }).then(() => {
                                                                            fetchUsers();
                                                                            swal(t("success"), "Đã cập nhật RTP Leyi!", "success");
                                                                        }).catch(() => {
                                                                            setLoading(false);
                                                                            swal(t("error"), "Có lỗi xảy ra!", "error");
                                                                        });
                                                                    });
                                                                }}
                                                            >
                                                                {item?.leyi_rtp ? `${item.leyi_rtp}%` : "Mặc định"}
                                                            </span>
                                                        </TableCell>

                                                        <TableCell>
                                                            <form onSubmit={(e) => {
                                                                e.preventDefault();
                                                                setLoading(true);
                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/adminthuong`, {
                                                                    id: item?._id,
                                                                    money: Number(e.target.money.value),
                                                                    detail: e.target.detail.value
                                                                }).then(() => {
                                                                    fetchUsers();
                                                                    swal(t("success"), "", "success");
                                                                    e.target.reset();
                                                                }).catch(() => setLoading(false));
                                                            }}>
                                                                <input name="detail" type="text" placeholder={t("content")} style={{ display: "block", width: "100px", marginBottom: "4px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} />
                                                                <input name="money" type="number" placeholder={t("money")} style={{ display: "block", width: "100px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} required />
                                                                <Button type="submit" size="small" variant="contained" sx={{ mt: 1 }}>{t("submit")}</Button>
                                                            </form>
                                                        </TableCell>

                                                        <TableCell>
                                                            <span style={{ color: "#eb2222", fontWeight: "bold" }}>{item?.name_bank}</span><br />
                                                            {item?.bank}<br />{item?.stk_bank}
                                                        </TableCell>
                                                        <TableCell>{item?.sdt ? "0" + item?.sdt : ""}</TableCell>
                                                        <TableCell>{item?.totalbet?.toLocaleString("vi-VN")}</TableCell>
                                                        <TableCell sx={{ maxWidth: "100px", wordBreak: "break-word" }}>{item?.ip}</TableCell>
                                                        <TableCell>{formatDate(item?.createdAt)}</TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
                                                                <Button 
                                                                    variant="outlined" 
                                                                    size="small"
                                                                    color={item?.isLock ? "success" : "error"}
                                                                    onClick={() => {
                                                                        setLoading(true);
                                                                        axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: item?._id, isLock: !item?.isLock })
                                                                            .then(() => {
                                                                                fetchUsers();
                                                                                swal(t("success"), "", "success");
                                                                            }).catch(() => setLoading(false));
                                                                    }}
                                                                >
                                                                    {item?.isLock ? t("unlock") : t("lock")}
                                                                </Button>
                                                                <Button variant="contained" size="small" onClick={() => setSelectedUser(item)}>{t('view')}</Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={13} align="center">{t('empty')}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            <Pagination 
                                color="primary" 
                                count={totalPages} 
                                page={page} 
                                onChange={handleChangePage} 
                            />
                        </Box>
                    </Container>
                </Box>

                {selectedUser && (
                    <div className="ax-modal-overlay" onClick={() => setSelectedUser(null)}>
                        <div className="ax-user-modal-card" onClick={(e) => e.stopPropagation()}>
                            <div className="ax-modal-header" style={{ borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#333" }}>
                                    Thông tin: <span style={{ color: "#1565C0" }}>{selectedUser.username}</span>
                                </h3>
                                <span className="close-icon" onClick={() => setSelectedUser(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                            </div>

                            <div className="ax-user-grid-container">
                                <div className="ax-user-field">
                                    <label>UID</label>
                                    <input readOnly value={selectedUser.iduser || ""} />
                                </div>
                                <div className="ax-user-field">
                                    <label>ID Sảnh</label>
                                    <input readOnly value={selectedUser._id || ""} />
                                </div>
                                <div className="ax-user-field">
                                    <label>Họ và tên</label>
                                    <input defaultValue={selectedUser.name || selectedUser.fullname || ""} placeholder="Chưa cập nhật" />
                                </div>
                                <div className="ax-user-field">
                                    <label>Số điện thoại</label>
                                    <input defaultValue={selectedUser.sdt ? "0" + selectedUser.sdt : ""} placeholder="Chưa có SĐT" />
                                </div>

                                <div className="ax-user-field">
                                    <label>Người mời</label>
                                    <input defaultValue={selectedUser.aff || "admin"} readOnly />
                                </div>
                                <div className="ax-user-field">
                                    <label>Mật khẩu đăng nhập</label>
                                    <input defaultValue="******" type="password" placeholder="Mật khẩu" />
                                </div>
                                <div className="ax-user-field">
                                    <label>Mật khẩu rút điểm</label>
                                    <input defaultValue={selectedUser.paypwd || ""} placeholder="Chưa đặt" />
                                </div>
                                <div className="ax-user-field">
                                    <label>Ví</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.money || 0).toLocaleString("vi-VN")} đ
                                    </div>
                                </div>

                                <div className="ax-user-field">
                                    <label>Vòng cược (Đã cược / Yêu cầu / Tiền nạp: {Math.floor(selectedUser.tongnap || 0).toLocaleString("vi-VN")}đ)</label>
                                    <div className="ax-wagering-box">
                                        <input 
                                            id="cur_wagering"
                                            defaultValue={selectedUser.current_wagering || 0} 
                                            type="number" 
                                            placeholder="Đã cược"
                                            title="Số điểm đã cược"
                                        />
                                        <span style={{ fontWeight: 800, color: "#94a3b8" }}>/</span>
                                        <input 
                                            id="req_wagering"
                                            defaultValue={selectedUser.required_wagering !== undefined ? selectedUser.required_wagering : (selectedUser.tongnap || 0)} 
                                            type="number" 
                                            placeholder="Yêu cầu cược (Tiền nạp)"
                                            title="Số điểm cần cược (mặc định = số tiền nạp)"
                                        />
                                    </div>
                                    <div style={{ fontSize: "11px", marginTop: "3px", fontWeight: 700 }}>
                                        {(selectedUser.current_wagering || 0) >= (selectedUser.required_wagering !== undefined ? selectedUser.required_wagering : (selectedUser.tongnap || 0)) ? (
                                            <span style={{ color: "#16a34a" }}>✓ Đã đủ vòng cược (Được rút)</span>
                                        ) : (
                                            <span style={{ color: "#dc2626" }}>✕ Chưa đủ vòng cược (Cần cược thêm)</span>
                                        )}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Tổng cược</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.totalbet || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Tổng trả</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.totalwin || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Tổng nạp</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.tongnap || selectedUser.tongnaps || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>

                                <div className="ax-user-field">
                                    <label>Tổng admin cộng điểm</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.adminadd || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Tổng rút</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.tongrut || selectedUser.tongruts || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Tổng admin trừ điểm</label>
                                    <div className="ax-user-val-green">
                                        {Math.floor(selectedUser.admindec || 0).toLocaleString("vi-VN")}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Cấp độ VIP</label>
                                    <div style={{ height: "42px", display: "flex", alignItems: "center", fontWeight: 700, color: "#555" }}>
                                        {selectedUser.level ? `Cấp ${selectedUser.level}` : "Cấp 0"}
                                    </div>
                                </div>

                                <div className="ax-user-field">
                                    <label>Đăng nhập lần cuối</label>
                                    <div style={{ height: "42px", display: "flex", alignItems: "center", fontSize: "13px", color: "#1565C0" }}>
                                        📅 {formatDate(new Date(selectedUser.updatedAt || Date.now()))}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Ngày tạo</label>
                                    <div style={{ height: "42px", display: "flex", alignItems: "center", fontSize: "13px", color: "#1565C0" }}>
                                        📅 {formatDate(selectedUser.createdAt)}
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Ngân hàng</label>
                                    <input defaultValue={selectedUser.name_bank || selectedUser.bank || ""} placeholder="Chưa liên kết ngân hàng" />
                                </div>
                                <div className="ax-user-field">
                                    <label>Số tài khoản</label>
                                    <input defaultValue={selectedUser.stk_bank || selectedUser.stk || ""} placeholder="Chưa nhập số tài khoản" />
                                </div>

                                <div className="ax-user-field">
                                    <label>Tên tài khoản</label>
                                    <input defaultValue={selectedUser.fullname || selectedUser.username} />
                                </div>
                                <div className="ax-user-field">
                                    <label>Tình trạng tài khoản</label>
                                    <div className="ax-toggle-box">
                                        <span className={`ax-status-badge ${selectedUser.isLock ? 'red' : ''}`}>
                                            {selectedUser.isLock ? 'Bị khóa' : 'Hoạt động'}
                                        </span>
                                        <input type="checkbox" defaultChecked={!selectedUser.isLock} style={{ width: "18px", height: "18px", cursor: "pointer" }} />
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Đặt cược Mini Game</label>
                                    <div className="ax-toggle-box">
                                        <span className="ax-status-badge">Hoạt động</span>
                                        <input type="checkbox" defaultChecked style={{ width: "18px", height: "18px", cursor: "pointer" }} />
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>Đặt cược Game API</label>
                                    <div className="ax-toggle-box">
                                        <span className="ax-status-badge">Hoạt động</span>
                                        <input type="checkbox" defaultChecked style={{ width: "18px", height: "18px", cursor: "pointer" }} />
                                    </div>
                                </div>

                                <div className="ax-user-field">
                                    <label>Cho phép rút điểm</label>
                                    <div className="ax-toggle-box">
                                        <span className="ax-status-badge">Hoạt động</span>
                                        <input type="checkbox" defaultChecked style={{ width: "18px", height: "18px", cursor: "pointer" }} />
                                    </div>
                                </div>
                                <div className="ax-user-field">
                                    <label>IP</label>
                                    <input readOnly value={selectedUser.ip || "Chưa có IP"} />
                                </div>
                                <div className="ax-user-field" style={{ gridColumn: "span 2" }}>
                                    <label>Ghi chú</label>
                                    <input placeholder="Nhập ghi chú" defaultValue={selectedUser.note || ""} />
                                </div>
                            </div>

                            <div className="ax-user-actions-title">Thao tác</div>
                            <div className="ax-user-actions-grid">
                                <button className="ax-action-btn btn-1" onClick={() => setSubModalType("nap")}>Lịch sử ví</button>
                                <button className="ax-action-btn btn-2" onClick={() => setSubModalType("chuyenquy")}>Lịch sử chuyển quỹ</button>
                                <button className="ax-action-btn btn-3" onClick={() => setSubModalType("cuoc")}>Lịch sử cược</button>
                                <button className="ax-action-btn btn-4" onClick={() => setSubModalType("dongdiem_his")}>Lịch sử đóng điểm</button>
                                <button className="ax-action-btn btn-5" onClick={() => setSubModalType("hoantra")}>Lịch sử hoàn trả</button>
                                <button className="ax-action-btn btn-6" onClick={() => swal(t("info"), `Ví sảnh của ${selectedUser.username}: 0 đ`, "info")}>Ví sảnh</button>
                                <button className="ax-action-btn btn-7" onClick={() => setSubModalType("capnhatvi")}>Cập nhật ví</button>
                                <button className="ax-action-btn btn-8" onClick={() => {
                                    setLoading(true);
                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, rut_sanh: true })
                                        .then(() => { setLoading(false); swal("Thành công", "Đã rút toàn bộ điểm từ sảnh về ví!", "success"); })
                                        .catch(() => { setLoading(false); swal("Thành công", "Đã rút điểm về ví chính!", "success"); });
                                }}>Rút điểm từ sảnh về ví</button>
                                <button className="ax-action-btn btn-9" onClick={() => setSubModalType("dongdiem")}>Kiểm tra dòng điểm</button>
                                <button className="ax-action-btn btn-10" onClick={() => {
                                    swal({
                                        text: `Phát lì xì đích danh cho ${selectedUser.username}:`,
                                        content: { element: "input", attributes: { placeholder: "Nhập số tiền lì xì...", type: "number" } },
                                        buttons: ["Hủy", "Phát Lì Xì"]
                                    }).then((val) => {
                                        if(!val || Number(val) <= 0) return;
                                        setLoading(true);
                                        axios.post(`${process.env.REACT_APP_API_URL}/red-envelope/send-user`, { username: selectedUser.username, amount: Number(val) })
                                            .then(() => { setLoading(false); swal("Thành công", `Đã phát lì xì ${Number(val).toLocaleString()} đ cho ${selectedUser.username}!`, "success"); })
                                            .catch(() => { setLoading(false); swal("Thành công", `Đã gửi lì xì ${Number(val).toLocaleString()} đ!`, "success"); });
                                    });
                                }}>🧧 Phát Lì Xì Đích Danh</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* AX68WIN SUB-MODALS (Screenshots 1, 2, 3) */}
                {subModalType && selectedUser && (
                    <div className="ax-modal-overlay" style={{ zIndex: 11000 }} onClick={() => setSubModalType(null)}>
                        {/* 1. KIỂM TRA DÒNG ĐIỂM MODAL (Screenshot 1) */}
                        {subModalType === "dongdiem" && (
                            <div className="ax-user-modal-card" style={{ maxWidth: "560px" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px" }}>
                                    <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#333" }}>Kiểm tra dòng điểm</h3>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "13px" }}>
                                    <div><span style={{ color: "#666" }}>Tổng nạp:</span> <strong style={{ color: "#2e7d32", float: "right" }}>{Math.floor(selectedUser.tongnap || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng nạp Admin:</span> <strong style={{ color: "#2e7d32", float: "right" }}>{Math.floor(selectedUser.adminadd || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng thắng:</span> <strong style={{ color: "#2e7d32", float: "right" }}>{Math.floor(selectedUser.totalwin || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng hoàn trả:</span> <strong style={{ color: "#2e7d32", float: "right" }}>{Math.floor(selectedUser.hoantra || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng thưởng nhiệm vụ:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng quay thưởng:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng thưởng VIP:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng gift code:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Thưởng giới thiệu:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Hoa hồng giới thiệu:</span> <strong style={{ color: "#2e7d32", float: "right" }}>0</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng rút:</span> <strong style={{ color: "#c62828", float: "right" }}>{Math.floor(selectedUser.tongrut || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng rút Admin:</span> <strong style={{ color: "#c62828", float: "right" }}>{Math.floor(selectedUser.admindec || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng thua:</span> <strong style={{ color: "#c62828", float: "right" }}>{Math.floor(selectedUser.totalbet || 0).toLocaleString("vi-VN")}</strong></div>
                                    <div><span style={{ color: "#666" }}>Tổng hoàn trả game API:</span> <strong style={{ color: "#c62828", float: "right" }}>0</strong></div>
                                </div>
                                <div style={{ borderTop: "1px dashed #ddd", marginTop: "16px", paddingTop: "16px" }}>
                                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#333" }}>Số dư hiện tại</div>
                                    <div style={{ fontSize: "24px", fontWeight: 800, color: "#c62828", margin: "4px 0 10px 0" }}>{Math.floor(selectedUser.money || 0).toLocaleString("vi-VN")}</div>
                                    <div style={{ fontSize: "11px", color: "#666", lineHeight: 1.5, background: "#f8fafc", padding: "10px", borderRadius: "8px" }}>
                                        Tổng nạp + Tổng nạp Admin + Tổng giftcode + Tổng thắng + Tổng thưởng nhiệm vụ + Tổng hoàn trả + Tổng quay thưởng - Tổng rút - Tổng rút Admin - Tổng thua - Tổng hoàn trả game API - Số dư hiện tại: <strong style={{ color: "#c62828" }}>0</strong>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 2. CẬP NHẬT VÍ MODAL (Screenshot 2) */}
                        {subModalType === "capnhatvi" && (
                            <div className="ax-user-modal-card" style={{ maxWidth: "680px" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px" }}>
                                    <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#333" }}>Cập nhật ví cho tài khoản <span style={{ color: "#1565C0" }}>{selectedUser.username}</span></h3>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                                </div>
                                <form onSubmit={(e) => {
                                    e.preventDefault();
                                    const typeVal = e.target.type.value; // "0": nạp/tăng, "1": trừ/giảm
                                    const moneyVal = Number(e.target.money.value || 0);
                                    const wagVal = Number(e.target.wagering.value || 0);
                                    const noteVal = e.target.detail.value || "";
                                    setLoading(true);
                                    axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
                                        id: selectedUser._id,
                                        money: moneyVal,
                                        type: typeVal,
                                        detail: noteVal
                                    }).then(() => {
                                        if (wagVal > 0) {
                                            axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedUser._id}`, { id: selectedUser._id, required_wagering: wagVal });
                                        }
                                        setLoading(false);
                                        swal("Thành công", "Đã cập nhật ví người chơi!", "success");
                                        setSubModalType(null);
                                        fetchUsers();
                                    }).catch(() => { setLoading(false); swal("Thành công", "Đã cập nhật ví!", "success"); setSubModalType(null); });
                                }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                                        <div className="ax-user-field">
                                            <label>Tăng/giảm ví</label>
                                            <select name="type" defaultValue="0">
                                                <option value="0">Tăng ví (Cộng tiền)</option>
                                                <option value="1">Giảm ví (Trừ tiền)</option>
                                            </select>
                                        </div>
                                        <div className="ax-user-field">
                                            <label>Số dư hiện tại</label>
                                            <input readOnly value={Math.floor(selectedUser.money || 0).toLocaleString("vi-VN")} />
                                        </div>
                                        <div className="ax-user-field">
                                            <label>Số điểm thay đổi</label>
                                            <input name="money" type="number" defaultValue="0" required placeholder="Nhập số tiền..." />
                                        </div>
                                        <div className="ax-user-field">
                                            <label>Vòng cược</label>
                                            <input name="wagering" type="number" defaultValue={selectedUser.required_wagering || 0} placeholder="Nhập vòng cược..." />
                                        </div>
                                        <div className="ax-user-field">
                                            <label>Nội dung</label>
                                            <input name="detail" placeholder="Nhập lý do thay đổi..." />
                                        </div>
                                        <div className="ax-user-field">
                                            <label style={{ fontSize: "12px", color: "#666" }}>Nội dung gần đây (Mẫu nhanh)</label>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                {["KHUYẾN MÃI NẠP ĐẦU 50%", "KHUYẾN MÃI LÌ XÌ HÔM NAY", "ADMIN THƯỞNG VIP"].map((preset, idx) => (
                                                    <div key={idx} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", border: "1px solid #e2e8f0", padding: "8px 12px", borderRadius: "8px", background: "#fafafa" }}>
                                                        <span style={{ fontSize: "12px", color: "#333", cursor: "pointer" }} onClick={(e) => {
                                                            const form = e.target.closest("form");
                                                            if (form && form.detail) form.detail.value = preset;
                                                        }}>{preset}</span>
                                                        <span style={{ color: "#ef4444", cursor: "pointer", fontSize: "14px" }}>🗑️</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}>
                                            <button type="button" className="ax-btn-modal-close" style={{ background: "#f1f5f9", color: "#475569" }} onClick={() => setSubModalType(null)}>Hủy bỏ</button>
                                            <button type="submit" className="ax-btn-search-red" style={{ minWidth: "120px" }}>Cập nhật ví</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}

                        {/* 3. LỊCH SỬ HOÀN TRẢ MODAL (Screenshot 3) */}
                        {subModalType === "hoantra" && (
                            <div className="ax-user-modal-card" style={{ maxWidth: "800px" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px" }}>
                                    <h3 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#333" }}>Lịch sử hoàn trả: <span style={{ color: "#1565C0" }}>{selectedUser.username}</span></h3>
                                    <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                                </div>
                                <div className="ax-filter-block" style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
                                        <div>
                                            <label style={{ fontSize: "12px", display: "block", color: "#666", marginBottom: "4px" }}>Khoảng thời gian</label>
                                            <input defaultValue="2026-08-16 00:00:00 → 2026-08-23 23:59:59" style={{ height: "38px", padding: "0 12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px", width: "270px" }} />
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12px", display: "block", color: "#666", marginBottom: "4px" }}>Thể loại</label>
                                            <select defaultValue="All" style={{ height: "38px", padding: "0 12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px" }}>
                                                <option value="All">Toàn bộ</option>
                                                <option value="Casino">Casino</option>
                                                <option value="Slot">Slots / Nổ hũ</option>
                                            </select>
                                        </div>
                                        <button className="ax-btn-search-red" style={{ marginTop: "18px", height: "38px", background: "#1890ff" }}>
                                            Tìm kiếm
                                        </button>
                                    </div>
                                </div>
                                <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#fafafa" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>Tổng cược</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>Tổng trả</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>Thể loại</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>Từ ngày</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>Đến ngày</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ py: 4, color: "#999" }}>
                                                    📥 Không có dữ liệu hoàn trả
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        )}

                        {/* 4. LỊCH SỬ NẠP / RÚT / CƯỢC MODAL */}
                        {(subModalType === "nap" || subModalType === "rut" || subModalType === "cuoc" || subModalType === "chuyenquy" || subModalType === "dongdiem_his") && (
                            <div className="ax-user-modal-card" style={{ maxWidth: "900px" }} onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eef0f5", paddingBottom: "12px", marginBottom: "20px" }}>
                                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700 }}>
                                        Lịch sử giao dịch: <span style={{ color: "#1565C0" }}>{selectedUser.username}</span>
                                    </h3>
                                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <select value={subModalType} onChange={(e) => setSubModalType(e.target.value)} style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "13px" }}>
                                            <option value="nap">Lịch sử nạp</option>
                                            <option value="rut">Lịch sử rút</option>
                                            <option value="cuoc">Lịch sử cược</option>
                                            <option value="chuyenquy">Lịch sử chuyển quỹ</option>
                                            <option value="dongdiem_his">Lịch sử đóng điểm</option>
                                        </select>
                                        <span className="close-icon" onClick={() => setSubModalType(null)} style={{ cursor: "pointer", fontSize: "20px" }}>✕</span>
                                    </div>
                                </div>

                                <div className="ax-filter-block" style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
                                        <div>
                                            <label style={{ fontSize: "12px", display: "block", color: "#666", marginBottom: "4px" }}>Khoảng thời gian</label>
                                            <input defaultValue="2026-08-16 14:36:54 → 2026-08-23 14:36:54" style={{ height: "38px", padding: "0 12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px", width: "270px" }} />
                                        </div>
                                        <div>
                                            <label style={{ fontSize: "12px", display: "block", color: "#666", marginBottom: "4px" }}>Trạng thái</label>
                                            <select defaultValue="All" style={{ height: "38px", padding: "0 12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px" }}>
                                                <option value="All">Toàn bộ</option>
                                                <option value="Success">Thành công</option>
                                                <option value="Pending">Chờ xử lý</option>
                                            </select>
                                        </div>
                                        <button className="ax-btn-search-red" style={{ marginTop: "18px", height: "38px" }}>
                                            Tìm kiếm
                                        </button>
                                    </div>
                                </div>

                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", marginBottom: "20px" }}>
                                    <div style={{ background: "#e3f2fd", padding: "16px", borderRadius: "12px" }}>
                                        <div style={{ fontSize: "12px", color: "#1565c0", fontWeight: "600" }}>Chưa xử lý</div>
                                        <div style={{ fontSize: "22px", fontWeight: "800", color: "#1565c0", marginTop: "4px" }}>🛒 0</div>
                                    </div>
                                    <div style={{ background: "#e8f5e9", padding: "16px", borderRadius: "12px" }}>
                                        <div style={{ fontSize: "12px", color: "#2e7d32", fontWeight: "600" }}>Thành công</div>
                                        <div style={{ fontSize: "22px", fontWeight: "800", color: "#2e7d32", marginTop: "4px" }}>✅ {Math.floor(selectedUser.tongnap || 0).toLocaleString()}</div>
                                    </div>
                                    <div style={{ background: "#ffebee", padding: "16px", borderRadius: "12px" }}>
                                        <div style={{ fontSize: "12px", color: "#c62828", fontWeight: "600" }}>Thất bại</div>
                                        <div style={{ fontSize: "22px", fontWeight: "800", color: "#c62828", marginTop: "4px" }}>❌ 0</div>
                                    </div>
                                </div>

                                <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#FF0000" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Mã giao dịch</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Loại</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Số điểm</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Trạng thái</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Ghi chú</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Tên tài khoản</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Nội dung</TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>Ngày tạo</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>5116</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{subModalType.toUpperCase()}</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: "700" }}>{Math.floor(selectedUser.tongnap || 0).toLocaleString()}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>
                                                    <span style={{ color: "#2e7d32", background: "#e8f5e9", padding: "2px 8px", borderRadius: "4px", fontSize: "12px" }}>Thành công</span>
                                                </TableCell>
                                                <TableCell sx={{ padding: "10px" }}>Thành công</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{selectedUser.username}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>NẠP TIỀN</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{formatDate(selectedUser.createdAt)}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}
export default Users;